import '@fontsource-variable/dm-sans';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initApi } from './api.ts';
import { currentToken, setAuthApiUrl } from './auth.ts';
import { loadConfig } from './config.ts';
import { initErrorReporting } from './errorReporting.ts';
import { SignInPage } from './pages/sign-in.tsx';
import { createConsoleRouter } from './router.tsx';
import { theme } from './theme.ts';

const router = createConsoleRouter();

const config = await loadConfig();
initErrorReporting(config, router);
setAuthApiUrl(config.apiUrl);
const signedIn = currentToken() !== null;
if (signedIn) initApi(config.apiUrl);
createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      {signedIn ? (
        <>
          <Notifications position="top-right" />
          <QueryClientProvider client={new QueryClient({ defaultOptions: { queries: { retry: false } } })}>
            <ModalsProvider>
              <RouterProvider router={router} />
            </ModalsProvider>
          </QueryClientProvider>
        </>
      ) : (
        <SignInPage apiUrl={config.apiUrl} />
      )}
    </MantineProvider>
  </StrictMode>,
);
